import {
    query,
    getDocs,
    QueryConstraint,
    QuerySnapshot,
    where
} from 'firebase/firestore';
import OwnerService from '../ownership/ownerService';
import { LandClass, LandInterface } from './index';

export const identifier = 'lands';

export default class LandService extends OwnerService<LandClass> {
    constructor() {
        super(identifier, LandClass);
    }

    /**
     * Get query depending on role
     * @param role the user role
     * @returns any
     */
    private getRoleQueries = (
        role?: string
    ): QueryConstraint | QueryConstraint[] => {
        const queries = {
            owner: where('owner', '==', this.logged.uid),
            editor: where('editors', 'array-contains', this.logged.uid),
            reader: where('readers', 'array-contains', this.logged.uid)
        };
        return role
            ? (queries[role] as QueryConstraint)
            : (Object.values(queries) as QueryConstraint[]);
    };

    /**
     * Get Docs depending on role
     * @param role the user role
     * @returns any
     */
    private getDocsRole = async (role: string): Promise<QuerySnapshot> => {
        const q = query(
            this.queryCollection,
            this.getRoleQueries(role) as QueryConstraint
        );
        return await getDocs(q);
    };

    /**
     * Get the list of lands including the shared ones
     * @returns List of lands as LandClass
     */
    getMyLands = async (): Promise<LandClass[]> => {
        const queries = [
            this.getDocsRole('owner'),
            this.getDocsRole('editor'),
            this.getDocsRole('reader')
        ];

        const docs = await Promise.all(queries);
        const results: LandClass[] = docs.reduce((acc, doc) => {
            doc.forEach((item) => {
                acc = [
                    ...acc,
                    new LandClass({
                        id: item.id,
                        ...(item.data() as Object)
                    } as LandInterface)
                ];
            });
            return acc;
        }, [] as LandClass[]);

        return results as LandClass[];
    };
}
